import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RefreshIcon from '@mui/icons-material/Refresh';

// Readiness includes authorization + snapshot + subscription, not just internet.
export default function RoomConnectionStatus({ state, onRetry }) {
    const { t } = useTranslation();
    if (state.ready) return null;
    const initializing = state.status === 'initializing' || state.status === 'idle';
    const synchronizing = state.status === 'synchronizing';
    const key = initializing ? 'connecting' : synchronizing ? (state.exhausted ? 'syncFailed' : 'synchronizing')
        : state.exhausted ? 'reconnecting' : 'recovering';
    return <div role="status" className="room-recovery-status" data-phase={initializing ? 'initializing' : synchronizing ? 'synchronizing' : 'recovery'}>
        <Typography>{t(`gameRoom.connectionLost.${key}`)}</Typography>
        {state.exhausted && <Button className="connection-retry-button" variant="contained" color="primary"
            startIcon={<RefreshIcon />} onClick={onRetry} sx={{ textTransform: 'none', fontWeight: 700,
                borderRadius: 2, px: 2, py: 1, border: '1px solid', borderColor: 'divider',
                boxShadow: 3 }}>{t('gameRoom.connectionLost.retry')}</Button>}
    </div>;
}
